import { Box } from '@chakra-ui/react'
import { REALTIME_SUBSCRIBE_STATES } from '~/utils/subscriptionHelpers'

type SubIndicatorProps = {
  subscriptionState: REALTIME_SUBSCRIBE_STATES | null
}

const SubscriptionIndicator = ({ subscriptionState }: SubIndicatorProps) => {
  const color = subscriptionState === 'SUBSCRIBED' ? 'green.500' : 'red.500'

  return (
    <Box
      w="8px"
      h="8px"
      borderRadius="full"
      bg={color}
      position="relative"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: 'full',
        bg: color,
        animation: 'ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite',
      }}
      sx={{
        '@keyframes ping': {
          '75%, 100%': {
            transform: 'scale(2)',
            opacity: 0,
          },
        },
      }}
    />
  )
}

export default SubscriptionIndicator
